var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Trans } from "react-i18next";
import TelephoneLink from "../../../ui/atoms/TelephoneLink";
var getSecuredInstallmentDataSections = function (accountSummaryData, autopayStatusData, helpNumber, t) {
    var _a;
    var billing = accountSummaryData.billing, credit = accountSummaryData.credit, installment = accountSummaryData.installment;
    var autopayValue = autopayStatusData.enrollment
        ? "grid.labels.autoPayStatus.on"
        : "grid.labels.autoPayStatus.off";
    var pastDue = Number((_a = accountSummaryData === null || accountSummaryData === void 0 ? void 0 : accountSummaryData.billing) === null || _a === void 0 ? void 0 : _a.pastDueAmount) > 0;
    var pastDueDataElements = [
        {
            value: billing === null || billing === void 0 ? void 0 : billing.outstandingFeesAndCharges,
            label: t("grid.labels.outstandingFeesAndCharges"),
            type: "amount",
        },
        {
            value: billing === null || billing === void 0 ? void 0 : billing.pastDueAmount,
            label: t("grid.labels.pastDueAmount"),
            type: "amount",
        },
    ];
    var helpNumberWithoutSpecialCharacters = helpNumber.replace(/[^0-9]/g, "");
    var telephoneLink = (_jsx(TelephoneLink, __assign({ href: "tel:".concat(helpNumberWithoutSpecialCharacters) }, { children: helpNumber })));
    var autopayStatusTooltip = (_jsx(Trans, { i18nKey: "grid.autopayStatusTooltip", components: {
            helpNumber: telephoneLink,
        } }));
    var securedInstallmentTotalLoanBalanceTooltip = (_jsx(Trans, { i18nKey: "grid.securedInstallmentTotalLoanBalanceTooltip", components: {
            helpNumber: telephoneLink,
        } }));
    return {
        dataSections: [
            {
                heading: t("grid.titles.paymentInformation"),
                sectionName: "payment-information",
                dataElements: __spreadArray([
                    {
                        value: billing === null || billing === void 0 ? void 0 : billing.fixedPaymentAmount,
                        label: t("grid.labels.monthlyPayment"),
                        type: "amount",
                    },
                    {
                        value: t(autopayValue),
                        label: t("grid.labels.autoPayStatus.text"),
                        type: "text",
                        toolTipText: autopayStatusTooltip,
                    }
                ], (pastDue ? pastDueDataElements : []), true),
            },
            {
                heading: t("grid.titles.loanInformation"),
                sectionName: "loan-information",
                dataElements: [
                    {
                        value: credit === null || credit === void 0 ? void 0 : credit.currentBalance,
                        label: t("grid.totalLoanBalance"),
                        type: "amount",
                        toolTipText: securedInstallmentTotalLoanBalanceTooltip,
                    },
                    {
                        value: installment === null || installment === void 0 ? void 0 : installment.interestRate,
                        label: t("grid.labels.currentInterestRate"),
                        type: "percentage",
                    },
                    {
                        value: installment === null || installment === void 0 ? void 0 : installment.startDate,
                        label: t("grid.labels.loanStartDate"),
                        type: "date",
                    },
                ],
            },
        ],
    };
};
export default getSecuredInstallmentDataSections;
//# sourceMappingURL=getSecuredInstallmentDataSections.js.map